export default (dis, store, client) => {
  function setTab(tab) {
    dis({ type: 'targetProfile/upsert', payload: { tab }})
  }

  return { setTab }
}
